export class AppAsyncTimeout {
  static setTimeout(fkt, ms=1) {
     return new Promise(() => setTimeout(() => {
       fkt();
     }, ms));
  }
}
